import WordModal from './WordModal.vue'
import Vue from 'vue'
import store from '@/store'

const WordModalConstructor = Vue.extend(WordModal)

export default function (options) {
  return new Promise(() => {
    if (typeof options === 'string') {
      options = {
        wordName: options
      }
    }

    const instance = new WordModalConstructor({
      store,
      data: options
    })
    instance.constructor = Vue
    instance.visible = true

    instance.$mount()
    document.body.appendChild(instance.$el)
  })
}
